import { Redirect } from 'expo-router'
import { useUser } from '@/queries/user.queries'
import { userPermissions } from '@/types/user'

export default function Home() {
  const user = useUser()

  if (user.data) {
    return <Redirect href={userPermissions(user.data).canViewDashboard ? '/dashboard' : '/cases'} />
  } else {
    return null
  }
}
